/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useState } from "react";

import styled from "styled-components";

import { API } from "../../classes/api";
import { useCurrentUser } from "src/app/useCurrentUser";
import { StandardButton } from "src/components/UI/Buttons/StandardButton";

interface Props {
  setInviteCode: React.Dispatch<React.SetStateAction<{ mnemonic: string; expiration: Date } | null>>;
  setInviteScreen: React.Dispatch<React.SetStateAction<"about" | "token">>;
}
export function AboutScreen({ setInviteCode, setInviteScreen }: Props) {
  const currentUser = useCurrentUser()!;
  const remainingInvites = currentUser.observe((state) => state.remainingInvites);

  const [daysValid, setDaysValid] = useState(3);

  const handleGenerateInvite = () => {
    const start = localStorage.getItem("mnemonic");
    API.users.createInvite(daysValid, start || undefined).then((invite) => {
      setInviteCode(invite);
      setInviteScreen("token");
      currentUser.consumeInvite();
    });
  };

  return (
    <>
      <InviteParagraph>You have {remainingInvites} invites left.</InviteParagraph>
      {/* picker for days valid */}
      <InviteParagraph>
        <label htmlFor="days-valid">Expires in </label>
        <input
          id="days-valid"
          type="number"
          value={daysValid}
          onChange={(e) => setDaysValid(parseInt(e.target.value))}
        />{" "}
        days
      </InviteParagraph>
      <StandardButton styles={{ marginTop: "220px", marginLeft: "auto" }} onClick={handleGenerateInvite}>
        Generate Invite
      </StandardButton>
    </>
  );
}

const InviteParagraph = styled.p`
  font-size: 16px;
  margin-top: 20px;
  font-family: "IBM Plex Mono";
`;
